import React from 'react';
import { Col, Row, Text, Input, SelectPicker } from 'rsuite';
import { ItemDataType } from 'rsuite/esm/MultiCascadeTree';
import { PERMIT_SORT_OPTIONS_ENUM } from '../../common/enums';

export interface PermitFiltersProps {
  searchFilter: string;
  setSearchFilter: (value: string) => void;
  sortFilter: PERMIT_SORT_OPTIONS_ENUM;
  setSortFilter: (value: PERMIT_SORT_OPTIONS_ENUM) => void;
  sortOptions: ItemDataType<PERMIT_SORT_OPTIONS_ENUM>[];
  statusFilter: PERMIT_SORT_OPTIONS_ENUM;
  setStatusFilter: (value: PERMIT_SORT_OPTIONS_ENUM) => void;
  statusOptions: ItemDataType<PERMIT_SORT_OPTIONS_ENUM>[];
  registrationVerbiage: string;
  registrationTypeVerbiage: string;
  ownerLabel: string;
}

const PermitFilters: React.FC<PermitFiltersProps> = ({
  searchFilter,
  setSearchFilter,
  sortFilter,
  setSortFilter,
  sortOptions,
  statusFilter,
  setStatusFilter,
  statusOptions,
  registrationVerbiage,
  registrationTypeVerbiage,
  ownerLabel,
}) => (
  <Row className="mb-20">
    <Col
      xs={24}
      md={12}
      className="sm-pb-10"
    >
      <Text className="mb-4 text-small">
        Search for a {registrationVerbiage}
      </Text>
      <Input
        className="ellipsis-placeholder"
        placeholder={`Search by address, ${registrationTypeVerbiage.toLowerCase()} number, ${ownerLabel} name...`}
        value={searchFilter}
        onChange={(value) => setSearchFilter(value)}
      />
    </Col>
    <Col
      xs={24}
      md={12}
      lg={5}
      lgPush={2}
      className="sm-pb-10"
    >
      <Text className="mb-4 text-small">Status</Text>
      <SelectPicker
        labelKey="name"
        valueKey="value"
        data={statusOptions}
        searchable={false}
        value={statusFilter}
        onSelect={(value) => setStatusFilter(value)}
        style={{ width: '100%' }}
        cleanable={false}
      />
    </Col>
    <Col
      xs={24}
      md={12}
      lg={5}
      lgPush={2}
      className="sm-pb-10"
    >
      <Text className="mb-4 text-small">Sort by</Text>
      <SelectPicker
        labelKey="name"
        valueKey="value"
        data={sortOptions}
        searchable={false}
        value={sortFilter}
        onSelect={(value) => setSortFilter(value)}
        style={{ width: '100%' }}
        cleanable={false}
      />
    </Col>
  </Row>
);

export default PermitFilters;
